import { Alert, AlertIcon, Box, Button, Flex, FormControl, FormLabel, HStack, Heading, Input, Stack, Text, useColorModeValue } from '@chakra-ui/react';
import GooglePlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-google-places-autocomplete';
import React, { useCallback, useEffect, useState } from 'react';
import { getUser, registerCompany } from '../../store/actions';
import { useAppDispatch, useAppSelector } from '../../hooks';

import { AppDispatch } from '../../store';
import { ToastContainer } from 'react-toastify';
import { addCompanyFormValidation } from '../../utils';
import { companyFormTypes } from '../../types';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';

export const AddCompany = () => {

    const [origin, setOrigin] = useState<any | null>(null);
    const [coords, setCoords] = useState<any | null>(null);

    const { user } = useAppSelector(state => state.userReducer);
    const { add_success_message, add_success } = useAppSelector(state => state.companyReducer);

    const dispatch: AppDispatch = useAppDispatch();

    const navigate = useNavigate();

    const companyForm = useFormik({
        initialValues: {
            name: '',
            phone: '',
            email: '',
            address: origin?.label,
            coords: {
                lat: coords?.lat,
                long: coords?.long,
            }
        },
        validationSchema: addCompanyFormValidation,
        validateOnBlur: true,
        onSubmit: (values: companyFormTypes) => {
            const address = origin?.label;
            // const { email } = user;
            // const {name, phone, coords } = values;
            const { lat, long }: any = coords;
            const newValues = { ...values, address, coords: { lat, long } };
            dispatch(registerCompany(newValues)).then(() => navigate('/'));
        }
    });

    const getCoords = useCallback(() => {
        origin && geocodeByAddress(origin?.label)
            .then((results: Array<any>) => getLatLng(results[0]))
            .then(({ lat, lng }: any) => {
                setCoords({ lat: lat, long: lng });
                companyForm.setFieldValue('coords.lat', lat);
                companyForm.setFieldValue('coords.long', lng);
            }
            );
    }, [origin]);

    useEffect(() => {
        getCoords();
    }, [coords, origin]);

    useEffect(() => {
        if (user?.company_id) navigate('/');
    }, [user?.company_id]);

    useEffect(() => {
        dispatch(getUser());
    }, []);

    return (
        <Flex
            minH={'-webkit-fill-available'}
            align={'center'}
            justify={'center'}
            // bg={useColorModeValue('gray.50', 'gray.800')}
            py={10}
        >
            <Stack>
                <Alert status='warning' borderRadius={6} mb={2} shadow={'sm'}>
                    <AlertIcon />
                    To start using trucklivery, you need to add your business details first.
                </Alert>
                <Box
                    rounded={'lg'}
                    bg={useColorModeValue('white', 'gray.700')}
                    boxShadow={'lg'}
                    p={8}>
                    <Stack spacing={4}>
                        {add_success_message &&
                            <Alert status={add_success ? 'success' : 'error'} borderRadius={4} mb={4}>
                                <AlertIcon />
                                {add_success_message}
                            </Alert>}
                        <Stack align={'center'} mb={6}>
                            <Heading display={'flex'} fontSize={'3xl'} textAlign={'center'}>
                                Add your Business.
                            </Heading>
                            <Text fontSize={'lg'} color={'gray.600'}>
                                To enjoy all of our cool features ✌️
                            </Text>
                        </Stack>
                        <form onSubmit={companyForm.handleSubmit}>
                            <FormControl id="name" isRequired mb={companyForm.errors.name ? 0 : 5}>
                                <FormLabel>Company name</FormLabel>
                                <Input name='name' type="text" value={companyForm.values.name} onChange={companyForm.handleChange} />
                                {companyForm.errors.name && <Text fontSize='sm' color='red.400'>{companyForm.errors.name}</Text>}
                            </FormControl>
                            <HStack>
                                <Box w={'50%'}>
                                    <FormControl id="phone" isRequired mb={companyForm.errors.phone ? 0 : 5}>
                                        <FormLabel>Phone number</FormLabel>
                                        <Input name='phone' type="text" value={companyForm.values.phone} onChange={companyForm.handleChange} />
                                        {companyForm.errors.phone && <Text fontSize='sm' color='red.400'>{companyForm.errors.phone}</Text>}
                                    </FormControl>
                                </Box>
                                <Box w={'50%'}>
                                    <FormControl id="email" isRequired mb={companyForm.errors.email ? 0 : 5}>
                                        <FormLabel>Email</FormLabel>
                                        <Input name='email' type="email" value={companyForm.values.email} onChange={companyForm.handleChange} />
                                        {companyForm.errors.email && <Text fontSize='sm' color='red.400'>{companyForm.errors.email}</Text>}
                                    </FormControl>
                                </Box>
                            </HStack>
                            <FormControl id="address" isRequired mb={origin ? 3 : 5}>
                                <FormLabel>Address</FormLabel>
                                <GooglePlacesAutocomplete
                                    apiKey='AIzaSyCsvDO2ZMssvwhcmIo2TqXvJSL0zlMD5bw'
                                    apiOptions={{ region: 'za' }}
                                    selectProps={{
                                        placeholder: 'Address',
                                        origin,
                                        onChange: setOrigin
                                    }}
                                />
                                {/* <Input name='address' type="text" value={companyForm.values.address} onChange={companyForm.handleChange} /> */}
                                {!origin && <Text fontSize='sm' color='red.400'>{'Enter your address'}</Text>}
                            </FormControl>
                            <Stack spacing={10} pt={2}>
                                <Button
                                    type='submit'
                                    isLoading={companyForm.isSubmitting}
                                    disabled={companyForm.isSubmitting}
                                    loadingText="Submitting"
                                    size="lg"
                                    colorScheme={'yellow'}>
                                    Submit
                                </Button>
                            </Stack>
                        </form>
                    </Stack>
                </Box>
            </Stack>
            <ToastContainer />
        </Flex>
    );
};